import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { goIndex } from '@/assets/js/utils'
import './Submit.less'

class App extends React.Component {
  static propTypes = {
      data: PropTypes.object
  };

  render () {
      const { data: { position, trackId, sublist, style = {} }, buriedPointEvent } = this.props
      let { textColor, backgroundColor, backgroundPicUrl, backgroundImage } = style
      /**
    * 1. 有backgroundColor,无论有没有backgroundImage,都显示backgroundColor
    * 2. 无backgroundColor, 显示backgroundPicUrl
    * 3. 无backgroundColor,无backgroundPicUrl, 显示默认的渐进色
    */
      if (!backgroundColor && !backgroundPicUrl) {
          backgroundImage = 'linear-gradient(100deg, #F4E1B7 0%, #DAB37C 100%)'
      } else if (!backgroundColor && backgroundPicUrl) {
          backgroundImage = `url(${backgroundPicUrl})`
      }
      return (
          <Fragment>
              {sublist.map(({ id, url, keyword, buttonText, title }, index) => (
                  <div
                      style={{
                          backgroundColor,
                          backgroundImage,
                          color: textColor || '#fff',
                          position: 'fixed',
                          bottom: 0,
                          width: '10rem',
                          height: 98 / 75 + 'rem',
                          lineHeight: 98 / 75 + 'rem'
                      }}
                      onClick={() => {
                          buriedPointEvent({
                              button_name: `${trackId}`,
                              button_id: `${id}`,
                              button_order: `${index + 1}`,
                              area_order: position,
                              button_area: `${position}-${trackId}`
                          })
                          goIndex(url, trackId, keyword)
                      }}
                      key={id}
                      className="submit-btn statistics-dom"
                  >
                      {buttonText || '默认文本'}
                  </div>
              ))}
          </Fragment>
      )
  }
}

export default App
